/**
 * #1650: the open listening session is kept in localStorage so a close, sleep or reload can still report its end.
 * Storage may be blocked or empty (private window, cleared data): every access is guarded and the app works without it.
 */
import { endFromSnapshot, isSnapshot } from './listeningSessionTypes';

export const OPEN_SESSION_KEY = 'maestro.listening.openSession.v1';
const MAX_STORED_AGE_MS = 7 * 86_400_000;
const LIVE_HEARTBEAT_MS = 120_000;

export const readStored = () => { try { return JSON.parse(window.localStorage.getItem(OPEN_SESSION_KEY) || 'null'); } catch { return null; } };
export const writeStored = (v) => { try { if (v) window.localStorage.setItem(OPEN_SESSION_KEY, JSON.stringify(v)); else window.localStorage.removeItem(OPEN_SESSION_KEY); } catch { /* storage may be blocked */ } };

/**
 * The stored copy of a session whose window is gone, as { event, meta } (the neutral app_closed end and the versions it ran
 * on), or null. A copy refreshed in the last 2 min belongs to another open window and is left alone. Clears what it takes.
 */
export function takeOrphanedEnd(now) {
  const stored = readStored();
  if (!stored) return null;
  const orphaned = stored.closing === true || now - Number(stored.lastAt) > LIVE_HEARTBEAT_MS;
  if (!orphaned) return null;
  writeStored(null);
  if (!isSnapshot(stored) || now - stored.lastAt >= MAX_STORED_AGE_MS) return null;
  return { event: endFromSnapshot(stored), meta: stored.meta || {} };
}
